import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthfakeauthenticationService } from '../../core/services/authfake.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-oem',
  templateUrl: './oem.component.html',
  styleUrls: ['./oem.component.scss']
})
export class OemComponent implements OnInit {
  superuser: any = null;
  mappedCustomers: any[] = [];
  filteredCustomers: any[] = [];
  searchTerm: string = '';
  breadCrumbItems: any[] = [];

  constructor(
    private router: Router,
    private authFakeService: AuthfakeauthenticationService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.breadCrumbItems = [{ label: 'OEM' }, { label: 'Customer Switcher', active: true }];
    const superUserBackupStr = sessionStorage.getItem('superUser');
    if (superUserBackupStr) {
      const superUser = JSON.parse(superUserBackupStr);
      this.authFakeService.updateCurrentUser(superUser);
      sessionStorage.removeItem('actingAsCustomer');
    }

    const currentUserStr = sessionStorage.getItem('currentUser');
    if (!currentUserStr) {
      this.toastr.error('No active session found. Please log in.');
      this.router.navigate(['/account/login']);
      return;
    }

    const currentUser = JSON.parse(currentUserStr);
    this.superuser = currentUser;
    sessionStorage.setItem('superUser', currentUserStr);

    this.mappedCustomers = this.superuser.mappedCustomers || [];
    this.filteredCustomers = [...this.mappedCustomers];
  }

  filterCustomers(): void {
    if (!this.searchTerm.trim()) {
      this.filteredCustomers = [...this.mappedCustomers];
      return;
    }
    
    const term = this.searchTerm.toLowerCase();
    this.filteredCustomers = this.mappedCustomers.filter(item => {
      const u = item.user;
      return (
        (u.customerName && u.customerName.toLowerCase().includes(term)) ||
        (u.custId && u.custId.toLowerCase().includes(term)) ||
        (u.email && u.email.toLowerCase().includes(term)) ||
        (u.mobileNumber && u.mobileNumber.toLowerCase().includes(term))
      );
    });
  }

  selectCustomer(customer: any): void {
    if (!customer || !customer.token || !customer.user) {
      this.toastr.error('Invalid customer selection details.');
      return;
    }

    const customerPayload = {
      result: 'success',
      token: customer.token,
      user: {
        ...customer.user,
        name: customer.user.customerName || customer.user.name,
        role: 'CUSTOMER'
      }
    };

    this.authFakeService.updateCurrentUser(customerPayload);
    sessionStorage.setItem('actingAsCustomer', 'true');
    this.toastr.success(`Switched context to ${customer.user.customerName}`);
    this.router.navigate(['/']);
  }

  logout(): void {
    this.authFakeService.logout();
    sessionStorage.clear();
    this.router.navigate(['/account/login']);
  }
}
